import { render, staticRenderFns } from "./LoginRemind.vue?vue&type=template&id=6d6a8958&scoped=true&"
import script from "./LoginRemind.vue?vue&type=script&lang=js&"
export * from "./LoginRemind.vue?vue&type=script&lang=js&"
import style0 from "./LoginRemind.vue?vue&type=style&index=0&id=6d6a8958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a8958",
  null
  
)

export default component.exports